<template>
  <section class="footer-contact">
    <!-- Image -->
    <figure class="footer-contact__image">
      <picture>
        <source
          media="--small"
          data-srcset="/static/images/get-in-touch-mobile.jpg,
          /static/images/get-in-touch-mobile@2x.jpg 2x,
          /static/images/get-in-touch-mobile@3x.jpg 3x"
        >

        <source
          media="--large"
          data-srcset="/static/images/get-in-touch.jpg, /static/images/get-in-touch@2x.jpg 2x"
        >

        <img
          class="lazyload top"
          data-sizes="auto"
          data-src="/static/images/get-in-touch.jpg"
        >
      </picture>
    </figure>

    <!-- Title -->
    <div class="footer-contact__title">
      {{ $t('footer_4') }}
    </div>

    <!-- Button -->
    <router-link :to="{ name: 'contact-form' }">
      <button-view variant="secondary">
        {{ $t('button_1') }}
      </button-view>
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'FooterContact',

  components: {
    ButtonView: () => import('@/components/button/button-view')
  }
};
</script>

<style lang="scss" src="@/assets/components/footer/footer-contact-view.scss"></style>



// WEBPACK FOOTER //
// footer-contact-view.vue